"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, // Add missing index for LTAR relations
"default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _globals = require("~/utils/globals");
const _models = require("~/models");
const _NcConnectionMgrv2 = /*#__PURE__*/ _interop_require_default(require("~/utils/common/NcConnectionMgrv2"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const logger = new _common.Logger('LTARIndexUpgrader');
// An upgrader for adding missing index of LTAR relations in XCDB sources
async function upgradeModelRelationsIndex(context, { model, indexes, ncMeta, sqlClient }) {
    // Iterate over each column and upgrade LTAR
    for (const column of (await model.getColumns(context, ncMeta))){
        if (column.uidt !== _nocodbsdk.UITypes.LinkToAnotherRecord) {
            continue;
        }
        const colOptions = await column.getColOptions(context, ncMeta);
        // if colOptions not found then skip
        if (!colOptions) {
            continue;
        }
        switch(colOptions.type){
            // use belongs to since child column belongs to current table in that case
            case _nocodbsdk.RelationTypes.BELONGS_TO:
                {
                    // const parentCol = await colOptions.getParentColumn(ncMeta);
                    const childCol = await colOptions.getChildColumn(context, ncMeta);
                    // const parentModel = await parentCol.getModel(ncMeta);
                    const childModel = await childCol.getModel(context, ncMeta);
                    // check index already exists or not
                    const indexExists = indexes.find((index)=>{
                        return index.cn === childCol.column_name;
                    });
                    if (indexExists) {
                        continue;
                    }
                    logger.log(`Creating index for column '${childCol.column_name}'`);
                    // create a new index for the column
                    const indexArgs = {
                        columns: [
                            childCol.column_name
                        ],
                        tn: childModel.table_name,
                        non_unique: true
                    };
                    // wrap in try catch to skip if index already exists
                    try {
                        await sqlClient.indexCreate(indexArgs);
                    } catch (e) {
                        // ignore throwing if the error is index already exists
                        if (!/relation "?.+"? already exists/i.test(e.message)) {
                            throw e;
                        }
                    }
                }
                break;
        }
    }
}
// An upgrader for adding missing index for LTAR relations in XCDB sources
async function upgradeBaseRelations(context, { ncMeta, source }) {
    const sqlClient = await _NcConnectionMgrv2.default.getSqlClient(source, ncMeta.knex);
    // get models for the base
    const models = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.MODELS);
    // get all columns and filter out relations and create index if not exists
    for (const model of models){
        var _ref;
        var _indexes_data;
        logger.log(`Upgrading model '${model.title}'`);
        logger.log(`Fetching index list of model '${model.title}'`);
        const indexes = await sqlClient.indexList({
            tn: model.table_name
        });
        const indexList = (_ref = (_indexes_data = indexes.data) == null ? void 0 : _indexes_data.list) != null ? _ref : [];
        // exclude composite indexes
        const filteredIndexList = indexList.filter((indexObj, i)=>{
            return indexList.every((indexObj2, j)=>{
                if (i === j) return true;
                return indexObj2.key_name !== indexObj.key_name;
            });
        });
        await upgradeModelRelationsIndex(context, {
            ncMeta,
            model: new _models.Model(model),
            sqlClient,
            indexes: filteredIndexList
        });
        logger.log(`Upgraded model '${model.title}'`);
    }
}
async function _default({ ncMeta }) {
    logger.log('Starting upgrade for LTAR relations in XCDB sources to add missing index');
    // get all xcdb sources
    const sources = await ncMeta.knexConnection(_globals.MetaTable.SOURCES).where({
        is_meta: 1
    });
    if (!sources.length) return;
    // iterate and upgrade each base
    for (const _base of sources){
        const source = new _models.Source(_base);
        const context = {
            workspace_id: source.fk_workspace_id,
            base_id: source.id
        };
        // skip if not pg, since for other db we don't need to upgrade
        if (ncMeta.knex.clientType() !== 'pg') {
            continue;
        }
        const base = await source.getProject(context, ncMeta);
        // skip deleted bases
        if (!base || base.deleted) continue;
        logger.log(`Upgrading source '${source.alias}'(${base.title})`);
        await upgradeBaseRelations(context, {
            ncMeta,
            source
        });
        logger.log(`Upgraded source '${source.alias}'(${base.title})`);
    }
    logger.log('Finished upgrade for LTAR relations in XCDB sources to add missing index');
}
